import $http from '$http';
import {
  cloneDeep,
  util,
  isCorrectVal,
  isDate,
  lg
} from 'utils';
export default {
  methods: {
    //获取列表
    getList() {
      let params = {
        Sid: this.$store.state.sysSid,
        Session: this.$store.state.sysSession,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      //过滤没有查询的值传入服务器
      for (let item in this.query) {
        let value = this.query[item];
        if (value !== "") {
          // 去除空格trimAllSpace(str, is_global)  true 为去除所有空格
          if (typeof value == 'string') {
            value = util.trimAllSpace(value);
          }
          this.query[item] = value
          params[item] = value;

        }
      }
      this.loading = true;
      let $href = 'api/UserSendGoods/GetUserSendGoodsStockList'
      // 判断路径来源
      if (this.$route.path == "/Family/SendNoticeStoreHouse") {
        // 仓库
        $href = 'api/UserSendGoods/GetUserSendGoodsStockList'
      } else if (this.$route.path == "/Family/SendNoticePackage") {
        // 资源包
        $href = 'api/UserSendGoods/GetUserSendGoodsResourceList'
      } else {
        // 海信
        $href = 'api/UserSendGoods/GetUserSendGoodsOtherList'
      }
      $http.get($href, params).then(res => {
        let {
          Data,
          Cnt
        } = res.data;
        this.loading = false;
        util.doResult(this, res, () => {
          this.lists = Data;
          this.totalSize = Cnt;
        });
      });
    },
  }
}


// WEBPACK FOOTER //
// ./src/pages/Family/SendNotice/services.js